import useAdmin from './useAdmin'

function contentEditableAware () {
  const isAdmin = useAdmin()
  const contentEditable = isAdmin && document.location.hash === '#key'
  return contentEditable
}

export default contentEditableAware
